import React from "react";
import styles from "./booking-flow-radio-indicator.module.css";

type BookingFlowRadioIndicatorProps = {
    checked: boolean;
    inverse?: boolean;
};

const BookingFlowRadioIndicator: React.FunctionComponent<BookingFlowRadioIndicatorProps> = ({
    checked,
    inverse = false,
}) => {
    const className = [
        styles.radio,
        inverse ? styles.radioInverse : "",
        checked
            ? inverse
                ? styles.radioCheckedInverse
                : styles.radioChecked
            : "",
    ]
        .filter(Boolean)
        .join(" ");

    return <span className={className} aria-hidden />;
};

export default BookingFlowRadioIndicator;
